export default "__VITE_ASSET__104c945c__"